"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _themeUi = require("theme-ui");

var _CustomFonts = _interopRequireDefault(require("./CustomFonts"));

var _GlobalStyles = _interopRequireDefault(require("./GlobalStyles"));

var _Reset = _interopRequireDefault(require("./Reset"));

require("./webfonts");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ThemeProvider = (0, _react.memo)(function (_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return _react["default"].createElement(_themeUi.ThemeProvider, props, _react["default"].createElement(_GlobalStyles["default"], null), _react["default"].createElement(_CustomFonts["default"], null), _react["default"].createElement(_Reset["default"], null), _react["default"].createElement(_themeUi.Styled.root, null, children));
});
ThemeProvider.displayName = 'ThemeProvider';
ThemeProvider.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = ThemeProvider;
exports["default"] = _default;